(function(){
  // CSS : corrige les largeurs du carousel et empeche le scroll horizontal
  var s=document.createElement('style');
  s.textContent='.lm-revcar__track{width:100%!important}.lm-revcar__card{flex-shrink:0!important;width:100%!important;min-width:100%!important;flex-basis:auto!important;box-sizing:border-box!important}html,body{overflow-x:hidden!important;max-width:100vw}.lm-gallery,.lm-gallery-main{overflow:hidden!important;max-width:100%!important}';
  document.head.appendChild(s);

  function fixCarousel(){
    var car=document.getElementById('lmRevCar');
    if(!car||car.dataset.lmfixed)return;
    car.dataset.lmfixed='1';
    var track=document.getElementById('lmRevTrack');
    if(!track)return;
    var dotEls=Array.from(car.querySelectorAll('.lm-revcar__dot'));
    var total=dotEls.length;
    if(!total)return;
    var cur=0;

    function go(n){
      cur=(n+total)%total;
      var w=car.offsetWidth;
      track.style.transform='translateX(-'+(cur*w)+'px)';
      dotEls.forEach(function(d,i){d.classList.toggle('active',i===cur);});
    }

    var pb=car.querySelector('.lm-revcar__prev');
    var nb=car.querySelector('.lm-revcar__next');
    if(pb){var np=pb.cloneNode(true);pb.parentNode.replaceChild(np,pb);np.addEventListener('click',function(){go(cur-1);});}
    if(nb){var nn=nb.cloneNode(true);nb.parentNode.replaceChild(nn,nb);nn.addEventListener('click',function(){go(cur+1);});}
    dotEls.forEach(function(d,i){
      var nd=d.cloneNode(true);
      d.parentNode.replaceChild(nd,d);
      nd.addEventListener('click',function(){go(i);});
    });
    dotEls=Array.from(car.querySelectorAll('.lm-revcar__dot'));

    var sx=0,sy=0,sw=false;
    track.addEventListener('touchstart',function(e){sw=true;sx=e.touches[0].clientX;sy=e.touches[0].clientY;},{passive:true});
    track.addEventListener('touchmove',function(e){
      if(!sw)return;
      var dx=e.touches[0].clientX-sx,dy=e.touches[0].clientY-sy;
      if(Math.abs(dx)>Math.abs(dy))e.preventDefault();
    },{passive:false});
    track.addEventListener('touchend',function(e){
      if(!sw)return;sw=false;
      var dx=e.changedTouches[0].clientX-sx,dy=e.changedTouches[0].clientY-sy;
      if(Math.abs(dx)<40||Math.abs(dx)<Math.abs(dy))return;
      go(cur+(dx<0?1:-1));
    },{passive:true});

    var t=setInterval(function(){go(cur+1);},7000);
    car.addEventListener('mouseenter',function(){clearInterval(t);});
    car.addEventListener('mouseleave',function(){t=setInterval(function(){go(cur+1);},7000);});
    car.addEventListener('touchstart',function(){clearInterval(t);},{passive:true});
    window.addEventListener('resize',function(){track.style.transition='none';go(cur);setTimeout(function(){track.style.transition='';},50);},{passive:true});
  }

  function fixGallery(){
    var gm=document.querySelector('.lm-gallery-main');
    if(!gm||gm.dataset.gfixed)return;
    gm.dataset.gfixed='1';
    var sx=0,sy=0,tk=false;
    gm.addEventListener('touchstart',function(e){tk=true;sx=e.touches[0].clientX;sy=e.touches[0].clientY;},{passive:true});
    gm.addEventListener('touchmove',function(e){
      if(!tk)return;
      var dx=e.touches[0].clientX-sx,dy=e.touches[0].clientY-sy;
      if(Math.abs(dx)>Math.abs(dy))e.preventDefault();
    },{passive:false});
    gm.addEventListener('touchend',function(){tk=false;},{passive:true});
  }

  function init(){fixCarousel();fixGallery();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
})();
